<template>
  <b-field>
    <b-datepicker
      placeholder="Seleccione una fecha"
      icon="calendar-today"
      trap-focus
      v-model="val"
      :month-names="months"
      :day-names="days"
      :first-day-of-week="1"
      :date-formatter="esLocaleFormatter"
    />
  </b-field>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

import { capitalize } from '@/utils/strings'

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  name: 'SchemaFormElementDatepicker',
  mixins: [SchemaFormElementMixin],
  data() {
    return {
      months: moment.months().map(month => capitalize(month)),
      days: moment.weekdaysMin()
    }
  },
  methods: {
    esLocaleFormatter(date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  created() {
    if (this.schema.default && !this.val && !this.value) {
      this.val = this.schema.default
    }
  }
}
</script>
